import React from "react";
import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./App.css";

import Navbar from "./components/Navbar";
import CartPreviewDrawer from "./components/client/CartPreviewDrawer";
import { CartProvider } from "./components/client/CartContext";

const App: React.FC = () => {
  return (
    <Router>
      <CartProvider>
        <Navbar />
        <CartPreviewDrawer />
      </CartProvider>
    </Router>
  );
};

export default App;
